export default __webpack_public_path__ + "static/media/CV__Berarma_Oussama.4d58206d.pdf";